import { CircularProgress, Stack } from "@vapor/material";

export default function BellLoading() {
  return (
    <Stack sx={{ backgroundColor: 'rgba(0,0,0,0.05)', zIndex: 9999, flexGrow: 1, alignItems: 'center', justifyContent: 'center', position: 'absolute', inset: 0 }}>
      <CircularProgress color="secondary" />
    </Stack>
  )
}
